import chroma from "chroma-js";
import colorPairsPicker from "color-pairs-picker";
import Radium from "radium";
import React from "react";
import { Link, RouteHandler } from "react-router";

import Logo from "./ui/_Logo";
import ReindexTypography from "./ui/_ReindexTypography";

import "css/github.css";

const headerColor = "white";
const headerColors = colorPairsPicker(headerColor, { contrast: 12 });
const darker = chroma(headerColor)
  .darken(9)
  .hex();
const activeHeaderColors = colorPairsPicker(darker, { contrast: 12 });
const { fontSizeToPx, rhythm } = ReindexTypography;
const footerColors = colorPairsPicker("#444444");
const dividerColor = chroma(footerColors.fg)
  .alpha(0.15)
  .css();
const styles = {
  page: {
    position: "absolute",
    width: "100%",
    minHeight: "100%",
    display: "flex",
    flexDirection: "column"
  },
  header: {
    marginBottom: rhythm(1.5),
    background: headerColors.bg,
    color: headerColors.fg
  },
  headerContainer: {
    maxWidth: 960,
    marginLeft: "auto",
    marginRight: "auto",
    padding: `0 ${rhythm(1 / 2)}`,
    display: "flex",
    alignItems: "center",
    height: 50
  },
  headerLinks: {
    flex: 1,
    display: "flex"
  },
  headerAccountLinks: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  headerLink: {
    textDecoration: "none",
    textTransform: "uppercase",
    fontWeight: 400,
    paddingLeft: rhythm(1 / 2),
    paddingRight: rhythm(1 / 2),
    height: 50,
    lineHeight: "55px",
    color: headerColors.fg
  },
  content: {
    flex: 1
  },
  footer: {
    background: footerColors.bg,
    color: footerColors.fg
  },
  footerContainer: {
    maxWidth: 960,
    marginLeft: "auto",
    marginRight: "auto",
    padding: `${rhythm(2)} ${rhythm(1)}`,
    display: "flex",
    flexWrap: "wrap",
    "@media (max-width: 800px)": {
      flexDirection: "column",
      alignItems: "center"
    }
  },
  footerList: {
    margin: "0 10px 0 0",
    listStyle: "none",
    display: "flex",
    flexWrap: "wrap",
    "@media (max-width: 800px)": {
      margin: `0 10px ${rhythm(1)} 0`,
      justifyContent: "center"
    }
  },
  footerLink: {
    ...fontSizeToPx("100%"),
    textDecoration: "none",
    color: footerColors.fg,
    marginRight: 10
  },
  footerSocialLink: {
    marginRight: 10,
    display: "block"
  },
  footerLastItemOfGroup: {
    borderRight: `1px solid ${dividerColor}`,
    "@media (max-width: 800px)": {
      borderRight: "none"
    }
  },
  footerLogo: {
    flex: 1,
    display: "flex",
    justifyContent: "flex-end"
  }
};

@Radium
export default class Page extends React.Component {
  render() {
    return (
      <div style={styles.page}>
        <header style={styles.header}>
          <div style={styles.headerContainer}>
            <Logo height={33} dark={true} />
            <div style={styles.headerLinks} />
            <div style={styles.headerAccountLinks}>
              <Link
                to="/team/"
                style={styles.headerLink}
                activeStyle={{
                  ...styles.headerLink,
                  backgroundColor: activeHeaderColors.bg,
                  color: activeHeaderColors.fg
                }}
              >
                Team
              </Link>
              <Link
                to="/blog/"
                style={styles.headerLink}
                activeStyle={{
                  ...styles.headerLink,
                  backgroundColor: activeHeaderColors.bg,
                  color: activeHeaderColors.fg
                }}
              >
                Blog
              </Link>
              <Link
                to="/docs/"
                style={styles.headerLink}
                activeStyle={{
                  ...styles.headerLink,
                  backgroundColor: activeHeaderColors.bg,
                  color: activeHeaderColors.fg
                }}
              >
                Docs
              </Link>
            </div>
          </div>
        </header>
        <div style={styles.content}>
          <RouteHandler {...this.props} />
        </div>
        <footer style={styles.footer}>
          <div style={styles.footerContainer}>
            <ul style={styles.footerList}>
              <li>
                <Link to="/team/" style={styles.footerLink}>
                  Team
                </Link>
              </li>
              <li>
                <Link to="/blog/" style={styles.footerLink}>
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/docs/" style={styles.footerLink}>
                  Docs
                </Link>
              </li>
              <li>
                <a
                  href="/policies/terms-and-conditions/"
                  style={styles.footerLink}
                >
                  Policies
                </a>
              </li>

              <li>
                <a
                    href="https://twitter.com/reindexio"
                    style={styles.footerLink}
                  >
                     Twitter
                  </a>
              </li>
              <li>
                <span style={styles.footerSocialLink}>
                  <a
                    href="https://github.com/reindexio"
                    style={styles.footerLink}
                  >
                    GitHub
                  </a>
                </span>
              </li>
            </ul>
            <div style={styles.footerLogo}>
              <Logo height={24} />
            </div>
          </div>
        </footer>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./_template.jsx
 **/